import classNames from "classnames";
// React
import React from "react";
// Bootstrap
import { Panel } from "react-bootstrap";
// Redux
import * as Redux from "redux";
import { connect } from "react-redux";
// Router
import { Link } from "react-router";
import * as authenticationActions from "user/authentication/actions";
// Components
import Page from "common/ui/components/page/Page";
import PageHeading from "common/ui/components/page/PageHeading";
import PageContainer from "common/ui/components/page/PageContainer";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./ProfileView.less";
const mapStateToProps = (state) => ({
    user: state.user
});
const mapDispatchToProps = (dispatch) => ({
    authenticationActions: Redux.bindActionCreators(authenticationActions, dispatch)
});
//-- Component -------------------------------------------------------------------------------------------------------------------------------
class ProfileView extends React.Component {
    resetPasswordCall() {
        let { authenticationActions } = this.props;
        // Create Dto
        let dto = { mobile: this.props.user.userInfo.mobile };
        // Submit to server
        authenticationActions.forgotPassword(dto);
    }
    render() {
        let { user } = this.props;
        if (!user.userInfo) {
            return React.createElement("div", null);
        }
        return (React.createElement(Page, null,
            React.createElement(PageHeading, { reportName: "Profile" }),
            React.createElement(PageContainer, null,
                React.createElement("div", { className: styles.container },
                    React.createElement(Panel, null,
                        React.createElement(Panel.Heading, null,
                            React.createElement("span", { className: styles.heading }, "Your Details")),
                        React.createElement(Panel.Body, null,
                            React.createElement("div", { className: styles.field },
                                React.createElement("div", { className: styles.title }, "Name:"),
                                React.createElement("div", { className: styles.value },
                                    user.userInfo.firstName,
                                    " ",
                                    user.userInfo.lastName)),
                            React.createElement("div", { className: styles.field },
                                React.createElement("div", { className: styles.title }, "Email:"),
                                React.createElement("div", { className: styles.value }, user.userInfo.email)),
                            React.createElement("div", { className: styles.field },
                                React.createElement("div", { className: styles.title }, "Mobile:"),
                                React.createElement("div", { className: styles.value }, user.userInfo.mobile)))),
                    React.createElement(Panel, null,
                        React.createElement(Panel.Heading, null,
                            React.createElement("span", { className: styles.heading }, "Account Management")),
                        React.createElement(Panel.Body, null,
                            React.createElement(Link, { className: classNames("btn", "btn-md", "btn-info", styles.link), to: "", onClick: () => this.resetPasswordCall() }, "Reset Password")))))));
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ProfileView);
